import axios from "axios";

export const state = {
    productitemunits: [],
};

export const getters = {
    productitemunits: state => state.productitemunits,
};

export const mutations = {
    SetProductitemunits(state, newValue) {
        state.productitemunits = newValue
    },
};

export const actions = {
    fetchItemUnits({ commit }) {
        axios.get('/productitemunits').then(res => {
            commit('SetProductitemunits', res.data.itemunits)
        })
    },
};
